import { InvalidContentError, isContentFragment } from '@oneaudi/falcon-tools';
import {
  CmsContent,
  ContentService,
  IFalconContentCFM,
  IFeatureAppContent,
} from './feature-service-types';
import { falconToAppContentMapper } from './mappers';
import demoContent from './mocks/demo-content.json';

function isFalconContent(content: CmsContent): content is IFalconContentCFM {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion
  return Boolean(isContentFragment(content) && 'showFloatingButtons' in content.fields);
}

export function normalizeContentService(contentService: ContentService): IFeatureAppContent {
  const content = contentService.getContent() as CmsContent;
  const isDevContent = content?.__type !== 'aem-headless' && content?.__type !== 'editor.json';
  const isEditorContent = content?.__type === 'editor.json';
  const isHeadlessContent = content?.__type === 'aem-headless' && isFalconContent(content);

  switch (true) {
    case isHeadlessContent:
      // necessary to add a FALCON Mapper to work with this APP
      return falconToAppContentMapper(content);
    case isDevContent:
      // App Store content and SSR development environment content
      return demoContent as IFeatureAppContent;
    case isEditorContent:
      // necessary to add a FACE Nemo Mapper to work with this APP
      throw new InvalidContentError('Editor content is not supported');
    default:
      throw new InvalidContentError('Spain omnichannel chat FA content is invalid.');
  }
}
